export default function sortByAttribute(items, attr) {
  if (attr === void 0) {
    attr = 'sort';
  }
  return items.sort((a, b) => {
    const aVal = typeof a[attr] === 'function' ? a[attr]() : a[attr];
    const bVal = typeof b[attr] === 'function' ? b[attr]() : b[attr];
    return aVal - bVal;
  });
}
flarum.reg.add('fof-terms', 'common/helpers/sortByAttribute', sortByAttribute);